import z from 'zod';

import { HandoffReferencesSchema } from '@polyai/stream/commands/handlers/handoff/schema';
import {
  SipConfigSchema,
  SipHeadersSchema,
} from '@polyai/stream/commands/handlers/handoff/shared';
import { handoffReferences } from '@polyai/stream/store/reducers/handoff';

export const CreateHandoffSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  description: z.string(),
  sipConfig: SipConfigSchema,
  sipHeaders: SipHeadersSchema,
  active: z.boolean().default(true),
  references: HandoffReferencesSchema.default(
    handoffReferences.createInitialState(),
  ),
});

export type CreateHandoffPayload = z.infer<typeof CreateHandoffSchema>;
